import React, { Component } from 'react';
import { Checkbox} from 'antd';
import intl from 'react-intl-universal';
import store from '@/store';
import { observer } from 'mobx-react';

class AITab extends Component {

    enableJavascriptActions(e){
        const appStore = store.appStore;
        const {aiUIFlag} = appStore;

        if(e.target.checked){
            appStore.setAIUIFlag(aiUIFlag|0b10);
            localStorage.setItem('ShowAIAssistantUI','true')
        }else{
            appStore.setAIUIFlag(aiUIFlag&0b01);
            localStorage.setItem('ShowAIAssistantUI','false')
        }
    }
    render() {
        const appStore = store.appStore;
        const {aiUIFlag} = appStore;
        return (
            <div className="preferences-javascript">            
                <div className="title">{intl.formatMessage({ id: 'GetStartGuid.aiAssistant' })}</div>
                <div className="board">
                    <Checkbox disabled={!(aiUIFlag&0b1)} className="ckb" checked={aiUIFlag==3} onChange={(e)=>{this.enableJavascriptActions(e)}}>
                        { intl.formatMessage({ id: 'Preferences.Content.AIEnabled' }) }
                    </Checkbox>
                </div>
            </div>
        )
    }
}

export default observer(AITab);